import React, { useEffect, useState } from "react";
import { useApiData } from "../hooks/useApiData";
import "./NoticeModal.css";

export default function NoticeModal() {
  const { data: notices, loading } = useApiData("important-notices");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show modal whenever notices are successfully loaded.
    if (!loading && notices && notices.length > 0) {
      setVisible(true);
    }
  }, [loading, notices]);

  const handleClose = () => {
    setVisible(false);
  };

  if (!visible || !notices || notices.length === 0) {
    return null;
  }

  return (
    <div
      className="notice-modal-overlay"
      onClick={handleClose}
    >
      <div
        className="notice-modal-box"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="notice-modal-header">
          <h2>IMPORTANT NOTICE</h2>

          <button
            type="button"
            className="notice-modal-close"
            onClick={handleClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        {/* Notice List */}
        <ul className="notice-modal-list">
          {notices.map((item) => (
            <li key={item.id}>
              <span className="notice-modal-arrow">
                ▶
              </span>

              <div className="notice-modal-content">
                {item.link ? (
                  <a
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="notice-modal-link"
                  >
                    {item.title}
                  </a>
                ) : (
                  <span className="notice-modal-title">
                    {item.title}
                  </span>
                )}

                {item.details && (
                  <span className="notice-modal-details">
                    {" — "}
                    {item.details}
                  </span>
                )}

                {/* {item.date && (
                  <span className="notice-modal-date">
                    ({item.date})
                  </span>
                )} */}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
